import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersRoutingModule } from './users-routing.module';
import { UsersComponent } from './users.component';
import { CreateUsersComponent } from './create-users/create-users.component';
import { UpdateUsersComponent } from './update-users/update-users.component';
import { ControlsModule } from 'src/app/shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReusableModule } from 'src/app/shared/reusable/reusable.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    UsersComponent,
    CreateUsersComponent,
    UpdateUsersComponent
  ],
  imports: [
    CommonModule,
    UsersRoutingModule,
    ControlsModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    ReusableModule,
    MatFormFieldModule,
    MatSelectModule,
    TranslateModule,
    MatDialogModule
  ]
})
export class UsersModule { }
